import { ExternalLink, Heart } from 'lucide-react'

export function CreatorLinks({ variant = 'full' }: { variant?: 'full' | 'compact' | 'footer' }) {
  if (variant === 'compact') {
    return (
      <div className="flex items-center gap-3 text-xs text-[var(--text-subtle)]">
        <a href="https://www.linkedin.com/in/mindful-abhay/" target="_blank" rel="noopener" className="link">Abhay</a>
        <span className="opacity-40">·</span>
        <a href="https://buymeacoffee.com/abhaypratapsingh" target="_blank" rel="noopener" className="link">Buy coffee</a>
      </div>
    )
  }
  if (variant === 'footer') {
    return (
      <div className="flex flex-col items-center gap-y-2 text-center text-sm text-[var(--text-muted)] pt-8 border-t border-[var(--border)]">
        <div className="flex flex-wrap justify-center items-center gap-x-6 gap-y-1.5">
          <a
            href="https://www.linkedin.com/in/mindful-abhay/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1.5 link hover:text-[var(--text)] transition-colors"
          >
            LinkedIn <ExternalLink size={13} />
          </a>
          <a
            href="https://buymeacoffee.com/abhaypratapsingh"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1.5 link hover:text-[var(--text)] transition-colors"
          >
            <Heart size={13} className="opacity-70" /> Buy Abhay a coffee
          </a>
        </div>
        <div className="text-[10px] text-[var(--text-subtle)] tracking-wide">A practice of the commons by Abhay Pratap Singh</div>
      </div>
    )
  }
  return (
    <div className="flex flex-wrap items-center gap-x-5 gap-y-1 text-sm text-[var(--text-muted)]">
      <a
        href="https://www.linkedin.com/in/mindful-abhay/"
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-1.5 link hover:text-[var(--text)] transition-colors"
      >
        LinkedIn <ExternalLink size={13} />
      </a>
      <a
        href="https://buymeacoffee.com/abhaypratapsingh"
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-1.5 link hover:text-[var(--text)] transition-colors"
      >
        Buy Abhay a coffee <ExternalLink size={13} />
      </a>
      <span className="text-[10px] text-[var(--text-subtle)] ml-1">A practice of the commons by Abhay Pratap Singh</span>
    </div>
  )
}
